import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const DSP_HANDLE_BATCH_NEW_ASSIGNMENT_OUT_FOR_DELIVERY_EVENT = gql`
  mutation DspHandleBatchNewAssignmentOutForDeliveryEvent($deliveryTaskOrderIdList: [Long!]!,$driverIdList: [Long!]!, $dspId: Long!, $operatorName: String) {
    result: dspHandleBatchNewAssignmentOutForDeliveryEvent(deliveryTaskOrderIdList: $deliveryTaskOrderIdList,driverIdList: $driverIdList, dspId: $dspId, operatorName: $operatorName) {
        success
        message
    }
  }
`;

interface DspHandleBatchNewAssignmentOutForDeliveryEventResponse {
    result: {
        success: boolean;
        message: string;
    };
}

export const DspHandleBatchNewAssignmentOutForDeliveryEvent = async (deliveryTaskOrderIdListInput: number[],driverIdListInput: number[], dspId: number, operatorName?: string | null): Promise<boolean> => {
    // 移除 __typename 字段，避免 GraphQL 输入类型错误
    const deliveryTaskOrderIdList = deliveryTaskOrderIdListInput.map(id => {
        const { __typename, ...cleanedId } = { id, __typename: undefined } as { id: number } & { __typename?: string };
        return cleanedId.id;
    });

    const driverIdList = driverIdListInput.map(id => {
        const { __typename, ...cleanedId } = { id, __typename: undefined } as { id: number } & { __typename?: string };
        return cleanedId.id;
    });

    const { data } = await client.mutate<DspHandleBatchNewAssignmentOutForDeliveryEventResponse>({
        mutation: DSP_HANDLE_BATCH_NEW_ASSIGNMENT_OUT_FOR_DELIVERY_EVENT,
        variables: {
            deliveryTaskOrderIdList: deliveryTaskOrderIdList,
            driverIdList:driverIdList,
            dspId: dspId,
            operatorName: operatorName || null
        }
    });
    return data?.result?.success || false;
};